import React, { useState, useCallback } from "react";
import "./header.css";
import Head from "../head/Head";
import { Link, useLocation } from "react-router-dom"; 
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import MonitorIcon from "@mui/icons-material/Monitor";
import TuneIcon from "@mui/icons-material/Tune";
import TableViewIcon from "@mui/icons-material/TableView";
import BarChartIcon from "@mui/icons-material/BarChart";
import PrintIcon from '@mui/icons-material/Print';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = useCallback(() => {
    setIsMobileMenuOpen(prev => !prev);
  }, []);

  const closeMobileMenu = useCallback(() => {
    setIsMobileMenuOpen(false);
  }, []);

  const navigationItems = [
    {
      path: -1, // This will navigate back in history
      icon: ArrowBackIcon,
      label: "Back",
      isActive: false,
      isBackButton: true
    },
    {
      path: "/",
      icon: DashboardOutlinedIcon,
      label: "Dashboard",
      isActive: location.pathname === "/"
    },
    {
      path: "/Acmonitoring",
      icon: MonitorIcon,
      label: "AC Monitoring",
      isActive: location.pathname === "/Acmonitoring"
    },
    {
      path: "/Accontroling",
      icon: TuneIcon,
      label: "AC Control Panel",
      isActive: location.pathname === "/Accontroling"
    },
    {
      path: "/table",
      icon: TableViewIcon,
      label: "Table",
      isActive: location.pathname === "/table"
    },
    {
      path: "/chart",
      icon: BarChartIcon,
      label: "Chart",
      isActive: location.pathname === "/chart"
    },
    {
      path: "/Report",
      icon: PrintIcon,
      label: "Report",
      isActive: location.pathname === "/Report"
    }
  ];

  return (
    <>
      <section className="header">
        <Head />
        <header>
          <div className="container">
            <nav aria-label="Main navigation">
              <ul 
                className={isMobileMenuOpen ? "navMenu-list" : "link"} 
                onClick={closeMobileMenu}
              >
                {navigationItems.map((item, index) => {
                  const IconComponent = item.icon;
                  return (
                    <li key={index}>
                      <Link 
                        to={item.path} 
                        className={`navLink ${item.isActive ? 'active' : ''}`}
                        aria-current={item.isActive ? 'page' : undefined}
                      >
                        <IconComponent 
                          className={`navIcon ${item.isActive ? 'active' : ''}`} 
                          aria-hidden="true"
                        />
                        <span className="navLabel">{item.label}</span>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </nav>
            
            <button 
              className="toggle" 
              onClick={toggleMobileMenu}
              aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
              aria-expanded={isMobileMenuOpen}
              aria-controls="main-navigation"
            >
              {isMobileMenuOpen ? <CloseIcon /> : <MenuIcon />}
            </button>
          </div>
        </header>
      </section>
    </>
  );
};

export default Header;